import type { AxiosResponse } from 'axios'
import type { AxiosOptions } from 'shared/api'
import { baseApi } from 'entities/Auth'
import {
  type IParamsGetClickToText,
  type IResponseGetClickToText,
  type IParamsClickToText,
  type IResponseClickToText,
  type IParamsGetContacts,
  type IResponseGetClickToTextStatisticLeads,
  type IResponseStatisticsClicks,
} from './type'

class Api {
  getClickToText(
    params: IParamsGetClickToText,
    options?: AxiosOptions
  ): Promise<AxiosResponse<IResponseGetClickToText>> {
    return baseApi.get('click-to-text/links', { params, ...options })
  }

  createClickToText(params: IParamsClickToText): Promise<AxiosResponse<IResponseClickToText>> {
    return baseApi.post('click-to-text/links', params)
  }

  getClickToTextById(id: string): Promise<AxiosResponse<IResponseClickToText>> {
    return baseApi.get(`click-to-text/links/${id}`)
  }

  updateClickToText(
    id: number,
    params: IParamsClickToText
  ): Promise<AxiosResponse<IResponseClickToText>> {
    return baseApi.put(`click-to-text/links/${id}`, params)
  }

  deleteClickToText(id: number): Promise<void> {
    return baseApi.delete(`click-to-text/links/${id}`)
  }

  getClickToTextStatisticsLeads(
    id: number,
    params: IParamsGetContacts,
    options?: AxiosOptions
  ): Promise<AxiosResponse<IResponseGetClickToTextStatisticLeads>> {
    return baseApi.get(`click-to-text/links/${id}/statistics/leads`, {
      params,
      ...options,
    })
  }

  getClickToTextStatisticsClicks(
    id: number,
    params: IParamsGetContacts,
    options?: AxiosOptions
  ): Promise<AxiosResponse<IResponseStatisticsClicks>> {
    return baseApi.get(`click-to-text/links/${id}/statistics/clicks`, {
      params,
      ...options,
    })
  }
}

export const ClickToTextApi = new Api()
